
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6af8a390\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MyAccount.vue")
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6af8a390\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./MyAccount.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./MyAccount.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6af8a390\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyAccount.vue"),
  /* scopeId */
  "data-v-6af8a390",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/views/MyAccount.vue
// module id = 1681
// module chunks = 1